module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 6.1"><path d="M0 3c0-.2.1-.3.3-.3h95.2l-1-2.7c1.4 1.2 3.7 2.4 5.5 3-1.8.7-4.1 1.8-5.5 3l1-2.7H.3C.1 3.4 0 3.2 0 3z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-long.svg
// module id = 12
// module chunks = 0